import { useState, useCallback } from 'react';
import { FormState } from '../types';
import { INITIAL_FORM_STATE } from '../styles';

export const useFormState = () => {
    const [formState, setFormState] = useState<FormState>(INITIAL_FORM_STATE);

    const updateField = useCallback((field: keyof FormState, value: string | boolean) => {
        setFormState(prev => ({ ...prev, [field]: value }));
    }, []);

    const resetForm = useCallback(() => {
        setFormState(INITIAL_FORM_STATE);
    }, []);

    return { formState, updateField, resetForm, setFormState };
};
